import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Listing, MoneyDisplay, MonoText } from "components";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import capitalise from "utils/capitalise";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  mono: {
    fontFamily: "Roboto Mono"
  }
}));

const Results = props => {
  const { className, models, filter, loading, onPageChange, title, ...rest } = props;

  const classes = useStyles();

  const handleTypeChange = (type) => {
    onPageChange({ type, offset: 0 });
  }

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      headerAction={<TypeToggle value={filter.type} handleFieldChange={handleTypeChange} />}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Price</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map((lesson, index) => (
            <TableRow key={index}>
              <TableCell className={classes.header}>
                {lesson.name_en}{lesson.name_zh ? " " + lesson.name_zh : ""}
                <div><Typography variant="caption">{capitalise(lesson.type)}</Typography></div>
              </TableCell>
              <TableCell>
                {capitalise(lesson.status) || "0"}
              </TableCell>
              <TableCell>
                <MonoText><MoneyDisplay amount={lesson.price} currency={lesson.price_currency} /></MonoText>              </TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`/lessons/${lesson.id}/summary`} variant="outlined">
                  View
                  </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

const TypeToggle = props => {
  const { handleFieldChange, value } = props;

  return (
    <ToggleButtonGroup
      exclusive
      onChange={(event, val) =>
        handleFieldChange(val)
      }
      size="small"
      value={value}
      variant="outlined"
    >
      <ToggleButton
        value="normal"
      >
        Normal
      </ToggleButton>
      <ToggleButton
        value="private"
      >
        Private
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default Results;